import { Colors, Services } from '@sigma-frontend-libs/commons'

import info from '@/components/info'

function renderHasFieldsError(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services['report-manager']}.errors.filterBy.noFields`),
        color: Colors.error
      }
    }
  )
}
function renderTypeEmptyInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services['report-manager']}.infos.filterBy.type.empty`),
        color: Colors.grey
      }
    }
  )
}
function renderRequiredError(h) {
  if (!this.requiredFieldsValidation) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${Services['report-manager']}.errors.filterBy.required`),
          color: Colors.error
        }
      }
    )
  }
}

function renderFieldByType(h, field, type) {
  const config = this.getRenderConfig(field, type)
  if (!config) {
    return null
  }

  return h(
    config.component,
    {
      props: config.props,
      key: `${this.type}-${field}`,
      on: config.on
    }
  )
}
function renderField(h, field, properties) {
  const { type, oneOf } = properties

  if (type) {
    return renderFieldByType.call(this, h, field, type)
  } else {
    switch (field) {
      case 'type':
      case 'status': return renderFieldByType.call(this, h, field, 'string')
      default: return oneOf.map(({ type }) => {
        return renderFieldByType.call(this, h, field, type)
      })
    }
  }
}
function renderFields(h) {
  return Object.keys(this.fields).map(key => {
    return renderField.call(this, h, key, this.fields[key])
  })
}

function renderInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services['report-manager']}.infos.filterBy.type.change`),
        color: Colors.warning
      }
    }
  )
}
function renderAsteriskInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate('hints.form.asterisk'),
        color: Colors.grey
      }
    }
  )
}

export default function(h) {
  if (!this.type) {
    return renderTypeEmptyInfo.call(this, h)
  }

  if (!this.hasFields) {
    return renderHasFieldsError.call(this, h)
  }

  return h(
    'div',
    {
      class: 'grid grid-gap--8 ptpx-12 px-2 pb-2'
    },
    [
      renderRequiredError.call(this, h),
      renderFields.call(this, h),
      renderInfo.call(this, h),
      renderAsteriskInfo.call(this, h)
    ]
  )
}
